export default function isRampley() {
  const href = window.location.href;
  return (href || '').toLowerCase().indexOf('rampley') !== -1;
}
